/**
 * BUGÜN, İSTANBUL TAKVİMİNE GÖRE.
 *
 * `new Date().toISOString().slice(0, 10)` UTC günü veriyor ve Türkiye UTC+3: saat 00:30'da
 * «bugün» dün görünüyor. Ölçüldü (29 Ekim 2026, 00:30): takvim bloğu bir önceki günü «bugün»
 * diye çiziyor, görüşme formuna düşen varsayılan tarih de bir gün geride açılıyordu.
 *
 * Türkiye 2016'dan beri sabit UTC+3 ve sunucu da aynı varsayımla okuyor (`fleet.tabular.ts`,
 * `hr.support.ts › today()`); yaz saati dönüşümü yok, bu yüzden sabit kaydırma doğru.
 */
export function todayIso(): string {
  return new Date(Date.now() + 3 * 3_600_000).toISOString().slice(0, 10);
}

/** Verilen ana İstanbul takvim günü — takvim ızgarasının gün anahtarları da bununla üretiliyor. */
export function dayIso(value: Date): string {
  return new Date(value.getTime() + 3 * 3_600_000).toISOString().slice(0, 10);
}
